import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/use-auth";

export function useIsAdmin() {
  const { session, loading: authLoading } = useAuth();
  const userId = session?.user.id;

  return useQuery<boolean>({
    queryKey: ["is-admin", userId],
    enabled: !authLoading && !!userId,
    queryFn: async () => {
      const { data } = await supabase
        .from("user_roles")
        .select("id")
        .eq("user_id", userId)
        .eq("role", "admin")
        .maybeSingle();
      return !!data;
    },
  });
}
